export default {
  1151: () => import('./LotteryPanel'),
  1152: () => import('./CreditPanel'),
  1153: () => import('./InviteBtn')
};
